import { useMutation } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { IRQCallbacks } from '../../types/my-types';

export const useRefreshedTransformed = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (extractionBatchId: string) =>
      await (await glynt).extractionBatch.refreshTransformed(extractionBatchId),

    ...callbacks
  });
};
